import React, {useState, useRef, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useRouter} from 'next/router';
import Image from 'next/image';
import axios from 'axios';
import Link from 'next/link';
import Spinner from 'react-bootstrap/Spinner';
import RCACompleteSummary from '../../rca/search/summary/RCACompleteSummary';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faTimes, faTimesCircle, faClock, faFilePdf, faShoppingCart, faCheck } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/cart/CartProduct.module.scss';
import { getCountryFromAbbr, getRCAStatus, mapVehicleFromServer } from '../../utils/compare/rcaUtils';
import {showRoDateAndTime, getDateTimeFromString} from '../../utils/general/Utilities';
import ErrorMessage from '../../elements/ErrorMessage';
import {saveProducts} from '../../cart/cartSlice';


const CartRCAProduct = (props) => {

    const {product, removeCartItem, editOption, requestApiData, addToCart} = props;
    const [isOpen, editIsOpen] = useState(false);
    const [viewVehicle, editViewVehicle] = useState(false);
    const [vehicle, editVehicle] = useState(product.vehicle);
    const [completeInfo, editCompleteInfo] = useState(requestApiData ? false : true);
    const [isLoading, editIsLoading] = useState(requestApiData ? true : false);
    const [isError, editIsError] = useState(false);
    const [addToCartRequest, editAddToCartRequest] = useState(false);
    
    const isMounted = useRef(null);
    const dispatch = useDispatch();
    const router = useRouter();
    const shoppingCart = useSelector(state => state.cart);


    useEffect( ()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        }
    }, [])


    useEffect( ()=>{
    
        if (shoppingCart.status == 'save' && addToCartRequest) {
            router.push('/cart');
        }
    }, [shoppingCart.status])

    const getVehicle = async () =>{
        const data  = await loadVehicleData();
        if (isMounted.current) {
            if (data && data.status == 'success') {
                const newVehicle = mapVehicleFromServer(product.vehicle, data.data, 'apiRequest');
                editVehicle(newVehicle);
                editCompleteInfo(true);
                editIsError(false);
            } else {
                editIsError('Ups, avem o eroare. Te rugăm să încerci mai tărziu.');
            }
            editIsLoading(false);
        }

    }

    const loadVehicleData = async()=>{
        try {
            const response = await axios({
                url: process.env.NEXT_PUBLIC_API + `/api/user/asigurari/rca/item/${product.id}/resource`,
                method: 'get',
                withCredentials: true,
            });

            const data = response.data;
            return data;
            

        } catch (err) {
            if (isMounted.current) {
                editIsError('Ups, avem o eroare. Te rugăm să încerci mai tărziu.');
                editIsLoading(false);
            }
        }
    }

    const showDetails = () => { editIsOpen(true); editViewVehicle(false);}
    const hideDetails = () => editIsOpen(false);
    const showVehicle = () => { 
        if (!completeInfo) {
            getVehicle();
        }
        editViewVehicle(true); editIsOpen(false); 
    }
    const hideVehicle = () => editViewVehicle(false);

    const image = {
        file: product.provider.logo,
        height: product.provider.logoSize ? product.provider.logoSize.height: null,
        width: product.provider.logoSize ? product.provider.logoSize.width: null,
        title: product.provider.societate_nume,
    };

    const details = {
        name: `Asigurare RCA pe ${product.durata} luni${product.decontare_directa ? ', Decontare directa' : ''} (valabilă din ${product.dataPolitaStart})`,
        price: product.prima,
        currency: 'Lei',
    };

    const feeText = product.comision_procent &&
        `${product.comision_procent}% (${Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(product.comision_valoare)} lei)`;

    let exCountriesList = product.excluderi_carte_verde.split(',');
    let exCountries = exCountriesList.map( item =>  {
        let country  = getCountryFromAbbr(item);
        if (country) {
            return country.name;
        }
        return item;
    })

    const expiresAt = getDateTimeFromString(product.expiresAt);
    const expirationDate = showRoDateAndTime(expiresAt);
    const isExpired = new Date() > expiresAt ? true : false;

    const offerFields = [
        {label: 'Societate de asigurare' , value: product.provider.societate_nume },
        {label: 'Tip asigurare' , value: 'Asigurare RCA' },
        {label: 'Data de început' , value: product.dataPolitaStart },
        {label: 'Durata' , value: `${product.durata} luni` },
        {label: 'Ofertă cu decontare directă' , value: `${product.decontare_directa ? 'Da' : 'Nu'}` },
        {label: 'Prima de asigurare' , value: `${Intl.NumberFormat('fr').format(product.prima)} lei` },
        {label: 'Clasa bonus-malus' , value: product.clasa_bm },
        {label: 'Identificator ofertă' , value: product.identificator_oferta },
        {label: 'Excluderi Carte Verde' , value: exCountries.join(', ') },
        {label: 'Comision (inclus în preț)' , value: feeText },
    ];

    if (product.status == 'NEW') {
        offerFields.push({label: 'Ofertă valabilă până la data' , value: expirationDate });
    }

    const closeVehicleButton = 
            <span className={`float-end ${styles.close}`} onClick={hideVehicle}>
                <FontAwesomeIcon icon={faTimesCircle} height="16" width="16" className="me-1"/>
                Închide
            </span>;
        
    const error = isError &&
        <div className="py-3">
            <ErrorMessage title="Eroare" message={isError} />
        </div>;

    const vehicleInfo = viewVehicle &&
        ( !isLoading ?
        <Col className="mt-3 bg-home" xs={12}>
            <div className={styles.divider} />
            <p className={`${styles.section} my-3`}>
                Autovehicul asigurat
               {closeVehicleButton}
            </p>
            {isError ? error :
            (completeInfo && <RCACompleteSummary vehicle={vehicle} edit="no"  />)
            }
            <p className="pb-3">
                {closeVehicleButton}    
            </p>
        </Col>
        :
        <Col className="mt-3 bg-home d-flex align-items-center justify-content-center p-5" xs={12}>
            <Spinner animation="border" />
        </Col>
        );


    const closeOfferButton = 
        <span className={`float-end ${styles.close}`} onClick={hideDetails}>
            <FontAwesomeIcon icon={faTimesCircle} height="16" width="16" className="me-1"/>
            Închide
        </span>;

    const offerDetails = isOpen && 
        <Col className={`mt-3 bg-home ${styles.summary}`} xs={12}>
            <div className={styles.divider} />
            <p className={`${styles.section} my-3`}>
                Detalii ofertă
               {closeOfferButton}
            </p>
            {offerFields.map ( (f, i) =>
            <Row key={i} className={styles.row}>
                <Col xs="12" md="6" className={styles.info}>
                {f.label}
                </Col>
                <Col xs="12" md="6" className={styles.selection}>
                    {f.value}
                </Col>
            </Row>
            )}
            <p className="pb-3">
                {closeOfferButton}
            </p>
        </Col>;

    const removeFromCart = () =>{ removeCartItem(product);}
    const editButton = (!editOption || editOption!='no') &&       
        <Col xs={6} className={`text-end`} >
            <Button variant="link" onClick={removeFromCart}> 
                <FontAwesomeIcon icon={faTimes} height="16" width="16" className="me-2 red"/>
                Șterge
            </Button>
        </Col>;

    const registrationStatus = completeInfo ? vehicle.car.tip_inmatriculare.value : vehicle.car.tip_inmatriculare;

    const issueInfo = (product.status == 'NEW' || product.status == 'ON HOLD') &&
            <p className={`${styles.info} mb-1`}>
                <FontAwesomeIcon icon={faClock} height="16" width="16" className="me-1 green"/>
                {registrationStatus == 'inmatriculat' ? 'Polița va fi emisă, imediat după confirmarea plății' : 'Polița va fi emisă după transmiterea documentelor privind achiziția (factura de la dealer/contract de vânzare-cumparare) la adresa asigurari@conso.ro.'}
            </p>;

    const expirationNotice = product.status == 'NEW' ?
        ( (isExpired || (!product.isAvailable)) ? 
        <p className={styles.info}>
            <Badge pill variant="danger" >
                Ofertă expirată
            </Badge>
        </p>
        :
        <p className={`text-success pt-1 mb-1 ${styles.info}`}>Ofertă valabilă până la {expirationDate}</p>
        ) 
        : ''
        ;

    const status = getRCAStatus(product.status);
    const insuranceStatus = product.status == 'NEW'  ? '' :
        <p>
            Status poliță: 
            <Badge pill variant="info" className="ms-2" >
                {status}
            </Badge>
        </p>;

    const addProductToCart = async () =>{
        editAddToCartRequest(true);
        if (completeInfo) {
            let newProducts = [...shoppingCart.products, product];
            dispatch(saveProducts({
                products: newProducts,
                status: 'save',
            }));
        } else {
            const data = await loadVehicleData();
            if (isMounted.current) {
                if (data && data.status == 'success') {
                    const newVehicle = mapVehicleFromServer(product.vehicle, data.data, 'apiRequest');
                    let newProduct = {...product, vehicle: newVehicle};
                    let newProducts = [...shoppingCart.products, newProduct];
                    dispatch(saveProducts({
                        products: newProducts,
                        status: 'save',
                    }));
                    
                } else {
                    editIsError('Ups, avem o eroare. Te rugăm să încerci mai tărziu.');
                }
            }
            
        }
        
    }

    const isProductInCart = shoppingCart.products.find( prod => prod.type=='rca' && prod.identificator_oferta == product.identificator_oferta) ? true : false;
            
    const buyButton = addToCart && product.isAvailable &&
        <div className="py-2">
            {isProductInCart ?
            <span>
                <FontAwesomeIcon icon={faCheck} height="16" width="16" className="me-2 green"/>
                Produsul este în coș
            </span>
            :
            <Button 
                onClick={addProductToCart}
                disabled={addToCartRequest ? true : false}
            >
                <FontAwesomeIcon icon={faShoppingCart} height="16" width="16" className="me-2"/>
                Adaugă în coș
            </Button>
            }
            
        </div>
        ;

    const carBrand = `${completeInfo ? vehicle.car.marca_auto.denumire : vehicle.car.marca_auto} ${vehicle.car.model_auto}`;

    return (
        <Row className={`${styles.root} mb-3`}>
            <Col xs={6}  >
                {product.provider.logoSize ?
                <Image
                    src={image.file}
                    width={image.width}
                    height={image.height}
                    title={image.title}
                    className={`pe-2`}
                />
                :
                <p className="font-weight-bold mb-0">{product.provider.societate_nume}</p>
                }
            </Col>
            {editButton}
            <Col xs={8} md={8}>
                <p className={styles.title}>{carBrand} - {details.name}</p>
            </Col>
            <Col xs={4} md={4} className={`${styles.title} text-end`}>
                {Intl.NumberFormat('fr').format(details.price)} {details.currency}
            </Col>
            <Col xs={12}>
                {!isExpired && issueInfo}
                {expirationNotice}
                {insuranceStatus}
                {buyButton}
            </Col>
            <Col xs={12} md={4} className={`${styles.edit}`}>
                <Button variant="link" onClick={showDetails} > 
                    <FontAwesomeIcon icon={faChevronRight} height="16" width="16" className="me-2"/>
                    Detalii
                </Button>
            </Col>
            <Col xs={12} md={4}  className={`${styles.edit}`}>
                <Button variant="link" onClick={showVehicle} > 
                    <FontAwesomeIcon icon={faChevronRight} height="16" width="16" className="me-2"/>
                   Auto asigurat
                </Button>
            </Col>
            {product.status == 'ISSUED' && 
            <Col xs={12} md={4}  className={`${styles.edit}`}>
                <Link
                    href={`${process.env.NEXT_PUBLIC_API}/api/user/download/rca/${product.id}`}
                    title="Descarcă polița RCA"
                    target="_blank"
                    className="btn btn-link">

                    <FontAwesomeIcon icon={faFilePdf} height="16" width="16" className="me-2 red"/>Descarcă polița
                                        
                </Link>
            </Col>
            }
            {offerDetails}
            {vehicleInfo}
        </Row>
    );
}

export default CartRCAProduct;